import React from 'react'

import Card from '@mui/material/Card';
import { Divider } from '@mui/material';

const ReviwerGuidlines = () => {
    return (
        <>
            <Card>
                <div className="row">
                    <div className="col-12 p-3 text-center">
                        <h3>REVIWER GUIDLINES</h3>
                    </div>
                </div>
            </Card>
            <Divider />

            <Card>
                <div className="row">
                    <div className="col-md-12 p-4 m-2 px-5">

                        <p>
                            <strong>

                                Reviewers Role and Responsibilities
                            </strong>
                        </p>


                        <p>

                            Reviewers provide an objective assessment of a submitted manuscript, and recommend whether a piece of work advances the field sufficiently to warrant authenticated publication.
                        </p>

                        <p>

<li>

                             Reviewer will be much appreciable in following time lines to give relevant comments on the
</li>
                            <li>

                             Assess the relevance of the work to the journal.
                            </li>
                            <li>

                            Check the novelty of original articles.
                            </li>
                            <li>

                            Ensure that all relevant work is cited and discussed as appropriate.
                            </li>
                            <li>

                        Check that the methodology is appropriate and properly described.
                            </li>
                            <li>

                            Verify whether the conclusions are supported by the results reported.
                            </li>
                            <li>

                            Check that any appropriate statistical analyses have been carried out.
                            </li>
                            <li>

                            Ensure that the paper is unambiguous and comprehensible, even if the English is not perfect.
                            </li>
                            <li>

                            Thoroughly go through the paper and indicate if the paper requires any English grammar, punctuation or spelling to be revised.
                            </li>
                            <li>

                            Scientific notations, equations, superscript, subscript, figure, diagrams, references, bibliography etc. are devoid of any errors.
                            </li>
                            <br />
                            ISSRA Publishers follows ‘Double-blind’ peer reviewing conceals both the authors’ and reviewers’ identities, to avoid potential bias against prestigious authors and influential authors who are judged on the paper rather than their reputation. Almost all papers submitted to reviewers for consideration will ultimately be accepted for publication or rejection; occasionally an author will withdraw their paper prior to have taken a decision. The best papers are innovative, well-researched, well-written and an asset to the respective journal field as it can set up a milestone in the field of scientific progress.
                            <br />
                        </p>


                        <p>
                            <strong>

                                Reviewers Opinion
                            </strong>
                        </p>

                        <p>

                            a. Major or Minor Revision: Common procedure under reviewing followed considering factors like English comprehension, references editing, results explanation, figure reformatting etc.
                            <br />
                            b. Reviewer Rejection: Reviewers have the capacity to make rejection for the manuscript if it is based on falsehood approach of presentation and scientific concept is not proven.
                            <br />
                            c. Acceptance: These manuscripts are acceptable as submitted if they are well written, easy to understand, if results support the conclusion, and they add to existing published knowledge extensively.
                            <br />
                        </p>

                    </div>
                </div>
            </Card>
        </>
    )
}

export default ReviwerGuidlines;